import { AudioLoopPlayer } from './audio/audioPlayer';
import { initOnboardingTour } from './ui/onboardingTour';
import { initContactModal } from './ui/contactModal';
import { decodeLoopFromUrl, hasShareLinkInUrl } from './sharing/loopShare';

// Dev/Prod mode flag
const isDev = import.meta.env.DEV;

// Initialize app when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    if (isDev) {
        console.log('[App] Initializing LooperC Audio Loop Player - Alpha 4...');
    }
    const player = new AudioLoopPlayer();
    initOnboardingTour();
    initContactModal();

    // Check for a shared loop in the URL hash (#loop=...)
    const sharedLoop = decodeLoopFromUrl();
    if (sharedLoop) {
        if (isDev) {
            console.log('[App] Shared loop detected in URL, loading:', sharedLoop.album);
        }
        player.loadSharedLoop(sharedLoop);
    } else if (hasShareLinkInUrl()) {
        player.showInvalidShareLink();
    }
});
